import { render, staticRenderFns } from "./DatatableColumns.vue?vue&type=template&id=0b0a508c&scoped=true&"
import script from "./DatatableColumns.vue?vue&type=script&lang=js&"
export * from "./DatatableColumns.vue?vue&type=script&lang=js&"
import style0 from "./DatatableColumns.vue?vue&type=style&index=0&id=0b0a508c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a508c",
  null
  
)

export default component.exports